export default __webpack_public_path__ + "static/banner1400-29d1fbce8f9a53f02b05e5a74823bdb0.png";